import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const initialState = {
    isLoading: false,
    error: null,
    stores: [],
  };


  const slice = createSlice({
    name: 'stores',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
  
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },
    
      getStoresSuccess(state, action) {
        state.isLoading = false;
        state.stores = action.payload;
      },

      addStoreSuccess(state, action) {
        const newStore = action.payload; 
        state.isLoading = false;
      },

      updateStoreSuccess(state, action) {
        state.isLoading = false;
      },

      deleteStoreSuccess(state, action) {
        state.isLoading = false;
      },

    },
  });

  // Reducer
  export default slice.reducer;
  

  
  // ----------------------------------------------------------------------
  

  export function getAllStores(){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.get('/api/stores');
        dispatch(slice.actions.getStoresSuccess(response.data.stores || []));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function addStore(data){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.post('/api/stores',data);
        dispatch(slice.actions.addStoreSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function updateStore(id,data){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.put(`/api/stores/${id}`,data);
        dispatch(slice.actions.updateStoreSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function deleteStore(id){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.delete(`/api/stores/${id}`);
        dispatch(slice.actions.deleteStoreSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }
